import {
  computedFillInBlankSumScore,
  getSubQuestions,
} from '@/features/test-paper/components/Blocks/Question/EditQuestion/utils'
import { InputNumber } from 'antd'
import { CircledNumber } from 'packages/components/CircledNumber'
import {
  PaperBlock,
  PaperBlockReq,
  PaperQuestion,
} from 'packages/sdks-next/growp'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { editQuestion } from '../../utils'
import { findIndex } from '@seiue/util'
import { useAtom } from 'jotai'
import { focusedBlockAtom } from '@/features/test-paper/components/BlockList/atoms'
import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { precisionFormat } from 'packages/utils'
import { EditPaperContext } from '../../context'

export const ProductFillScoreSetting: React.FC<{
  index: number
  firstLevelSubQuestion: PaperQuestion
  block: PaperBlock
  onUpdateScore: (blockId: number, payload: PaperBlockReq) => void
  mainQuestion: PaperQuestion
}> = ({ index, firstLevelSubQuestion, block, onUpdateScore, mainQuestion }) => {
  const { limitLevel } = useContext(EditPaperContext)
  const [focusedBlock, setFocusedBlock] = useAtom(focusedBlockAtom)
  const secondLevelQuestions = getSubQuestions(
    block.questions || [],
    firstLevelSubQuestion.id
  )
  return (
    <>
      <Wrapper>
        <LabelWrapper $isMainSub={true}>
          <LIcon />
          <div>({index + 1})填空</div>
        </LabelWrapper>
        <div style={{ width: '85px', textAlign: 'right' }}>
          {precisionFormat(firstLevelSubQuestion.score)}分
        </div>
      </Wrapper>
      {secondLevelQuestions.map((question, index) => {
        return (
          <Wrapper key={index}>
            <LabelWrapper>
              <LIcon />
              <CircledNumber number={index + 1} />
            </LabelWrapper>
            <InputNumber
              disabled={
                limitLevel > 1 || focusedBlock.state === BlockStateEnum.Editing
              }
              onFocus={() => {
                const ele = document.getElementById(`${block.id}`)
                if (ele) {
                  setFocusedBlock({
                    id: block.id,
                    state: BlockStateEnum.Selected,
                  })
                  ele.scrollIntoView({ block: 'center', behavior: 'smooth' })
                }
              }}
              value={precisionFormat(question.score)}
              onChange={(e) => {
                const v = precisionFormat(e)
                const newQuestions = editQuestion(
                  block.questions || [],
                  question.id,
                  {
                    score: v ? String(v) : undefined,
                  }
                )
                const i = findIndex(
                  newQuestions,
                  (q) => q.id === question.parentId
                )
                newQuestions.splice(i, 1, {
                  ...firstLevelSubQuestion,
                  score: String(
                    computedFillInBlankSumScore(
                      getSubQuestions(newQuestions, firstLevelSubQuestion.id)
                    )
                  ),
                })
                const mainQuestionIndex = findIndex(newQuestions, {
                  id: mainQuestion.id,
                })

                newQuestions.splice(mainQuestionIndex, 1, {
                  ...mainQuestion,
                  score: String(
                    computedFillInBlankSumScore(
                      getSubQuestions(newQuestions, mainQuestion.id)
                    )
                  ),
                })

                onUpdateScore(block.id, {
                  ...block,
                  questions: newQuestions,
                })
              }}
            />
          </Wrapper>
        )
      })}
    </>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div {
    font-size: 14px;
    color: ${(props) => props.theme.text._1};
  }
`

const LabelWrapper = styled.div<{ $isMainSub?: boolean }>`
  width: 95px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: ${(props) => (props.$isMainSub ? 0 : '16px')};
`

const LIcon = styled.div`
  width: 6px;
  height: 6px;
  margin-right: 4px;
  border-left: 1px solid #afbdc7;
  border-bottom: 1px solid #afbdc7;
`
